// Copyright (c) 2020 Deere & Company

import FacetsAccordionContainer from './facets-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    facetFilterText: state.tabm.wip.facetFilterText,
    facets: state.tabm.wip.wipFacets,
    filteredTerritories: state.tabm.wip.filteredTerritories,
    selectedSpaLevels: state.tabm.wip.selectedSpaLevels,
    tcsmSettings: state.tabm.wip.tcsmSettings,
    territories: state.user.territories
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {
        readSpaClaims,
        resetTcsmSettingsFacet,
        resetWipFacets,
        toggleSpaLevelsListItems,
        updateFacetFilterText,
        updateFilteredTerritories,
        updateSelectedSpaLevelsList,
        updateWipFacets
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            readSpaClaims,
            resetTcsmSettingsFacet,
            resetWipFacets,
            toggleSpaLevelsListItems,
            updateFacetFilterText,
            updateFilteredTerritories,
            updateSelectedSpaLevelsList,
            updateWipFacets
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(FacetsAccordionContainer);



// WEBPACK FOOTER //
// ./src/tabm/wip/components/facets/index.js